module.exports = __webpack_public_path__ + "img/my-schedule-preview-clinician-dashboard.be0ee561.png";